import * as ailabsApi from '../../../api/ailabs';
import * as DeviceDetector from 'device-detector-js';

const detector = new DeviceDetector();
const device = detector.parse(navigator.userAgent);

export function kakaoData() {
  return {
    phone: '',
    isPopupOpened: false,
    inputStep: 1,

      init() {
          window.js.openSnsPopup = () => {
              this.isPopupOpened = true;
          }
      },

    openSnsPopup() {
      this.isPopupOpened = true;
    },

    closeSnsPopup() {
      this.isPopupOpened = false;
    },

    prepareSend() {
      this.inputStep = 2;
    },

    back() {
      this.inputStep = 1;
    },

    async sendAlimtalk() {
      await ailabsApi.sendConsultantMessage(this.phone);

      this.inputStep = 3;
    },
  };
}
